import React from 'react';

import Box, { BoxProps } from 'carbon-react/lib/components/box';

export const WizardFormDivider = (props?: BoxProps) => {
  return <Box my={3} backgroundColor="--colorsUtilityMajor100" height="1px" as="hr" {...props} />;
};
